import { type ISbStoryData } from "@storyblok/react"

/**
 * Get the href from a story.
 *
 * @param {object} story - The story
 * @returns {string} The href of the story
 */

export const getStoryHref = (story: ISbStoryData) => {
    return `/${story.full_slug}`
}
